var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashbin = function SvgTrashbin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6a1.5 1.5 0 0 0-3 0h-1a2.5 2.5 0 0 1 5 0H19a.5.5 0 0 1 0 1h-.554L17.15 18.23A2 2 0 0 1 15.163 20H8.837a2 2 0 0 1-1.987-1.77L5.553 7H5a.5.5 0 0 1-.492-.41L4.5 6.5A.5.5 0 0 1 5 6h8.5Zm3.938 1H6.561l1.282 11.115a1 1 0 0 0 .994.885h6.326a1 1 0 0 0 .994-.885L17.438 7ZM10.5 9.5c.245 0 .45.155.492.359l.008.079v6.124c0 .242-.224.438-.5.438-.245 0-.45-.155-.492-.359L10 16.063V9.938c0-.242.224-.438.5-.438Zm3 0c.245 0 .45.155.492.359l.008.079v6.124c0 .242-.224.438-.5.438-.245 0-.45-.155-.492-.359L13 16.063V9.938c0-.242.224-.438.5-.438Z",
    fill: "#697077"
  })));
};
export default SvgTrashbin;